import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';

import * as rootReducer from 'app/core/store/reducers';
import * as fromDeliverySelectors from 'app/core/store/selectors/delivery.selectors';
import { Delivery } from 'app/core/models';

@Component({
  standalone: false,
  selector: 'pptl-modal-metadata',
  templateUrl: './modal-metadata.component.html',
  styleUrls: ['./modal-metadata.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalMetadataComponent implements OnInit {
  readonly noImageUrl = '/assets/logo/logo_new_white.png';
  delivery$: Observable<Delivery>;
  isLoading$: Observable<boolean>;

  constructor(
    public modalController: ModalController,
    private router: Router,
    private store: Store<rootReducer.State>,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.isLoading$ = this.store.pipe(select(fromDeliverySelectors.getDeliveryLoading));
    this.setDeliveryData();
  }

  onCancelButtonClick(): void {
    this.dismissModal();
  }

  swipeHandler(): void {
    this.dismissModal();
  }

  tapModalHandler(delivery: Delivery): void {
    this.dismissModal();
    if (!delivery.expired) {
      this.router.navigate([`/delivery/${delivery.deliveryKeyCode}`]);
    }
  }

  dismissModal(): void {
    this.modalController.dismiss();
  }

  getImage(delivery: Delivery): any {
    const isOffline = delivery.deliveryImage.includes('file://');
    if (!isOffline) {
      return delivery.deliveryImage;
    }
    const url: SafeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
      Capacitor.convertFileSrc(delivery.deliveryImage).replace('undefined/', ''),
    );
    return url || this.noImageUrl;
  }

  private setDeliveryData() {
    this.delivery$ = this.store.pipe(
      select(fromDeliverySelectors.getDeliveryData),
      filter((resp) => !!(resp && resp.deliveryKeyCode)),
    );
  }
}
